export const USER_PERSONAS = [
  'fabric_manufacturer',
  'fabric_distributor',
  'garment_manufacturer',
  'brand_owner',
  'retail_store',
  'agency',
  'fashion_designer',
];

export const USER_PERSONA_LABELS = {
  fabric_manufacturer: 'Fabric Manufacturer',
  fabric_distributor: 'Fabric Distributor',
  garment_manufacturer: 'Garment Manufacturers',
  brand_owner: 'Brand Owner',
  retail_store: 'Retail store',
  agency: 'Agency',
  fashion_designer: 'Fashion Designer',
};

export const getPersonaLabel = (persona) => USER_PERSONA_LABELS[persona] || persona;

export const normalizePersonasList = (personas) => {
  if (typeof personas === 'string' && personas.trim()) {
    return normalizePersonasList([personas.trim()]);
  }
  if (!Array.isArray(personas)) return [];
  return personas
    .map((persona) => String(persona || '').trim())
    .filter(Boolean);
};

export const formatPersonaLabels = (personas = []) =>
  normalizePersonasList(personas).map(getPersonaLabel).join(', ');
